<template>
  <v-dialog scrollable v-model="showDialog" max-width="500px">
    <v-card>
      <v-layout>
        <v-card-title class="headline">
          <strong class="headline deep-purple--text">
            Orçamento Adicional
          </strong>
        </v-card-title>
      </v-layout>
      <v-divider class="deep-purple" />
      <v-layout
        row
        wrap
        justify-center
        align-baseline
        class="mx-3 mt-4"
        style="gap: 1rem"
      >
        <v-flex>
          <v-text-field
            label="Orçamento Adicional"
            v-model.number="aditional"
            type="number"
            step="0.01"
            box
            prefix="R$"
            placeholder="0.00"
            @blur="formatNumber"
          />
        </v-flex>
      </v-layout>

      <v-divider class="deep-purple" />
      <v-card-actions class="py-2">
        <v-btn flat color="primary" @click="closeModal">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="deep-purple" dark @click="save" :disabled="!aditional">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      aditional: null,
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    closeModal() {
      this.showDialog = false;
      this.aditional = null;
      this.$emit("close");
    },
    save() {
      this.$emit("salvar", this.aditional);
      this.showDialog = false;
      this.aditional = null;
    },
    formatNumber() {
      if (this.aditional) {
        this.aditional = parseFloat(this.aditional).toFixed(2);
      } else {
        this.aditional = null;
      }
    },
  },
};
</script>
